<template>
  <el-popover
    v-model:visible="visible"
    trigger="click"
    placement="bottom-end"
    popper-class="FilterColumn"
    :width="220"
    :teleported="true"
    :hide-after="0"
    @show="handleShow(true)"
  >
    <template #reference>
      <el-button circle title="列设置">
        <el-icon :size="16">
          <Setting />
        </el-icon>
      </el-button>
    </template>
    <div class="flex-a flex-between title">
      <el-checkbox
        :model-value="checkAll"
        :indeterminate="isIndeterminate"
        @change="handleCheckAllChange"
      >
        列展示
      </el-checkbox>
      <el-button size="small" link type="primary" @click="handleReset">重置</el-button>
    </div>
    <div style="margin: 15px 0;" />
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <el-checkbox
        v-for="(item, index) in colData"
        :key="index"
        :label="item.title"
        :value="item.title"
      >
        {{ item.title }}
      </el-checkbox>
    </el-checkbox-group>
  </el-popover>
</template>

<script>
import { Setting } from "@element-plus/icons-vue";

export default {
  components: { Setting },
  props: {
    colData: Array,
    newColData: Array
  },
  data() {
    return {
      checkAll: false,
      checkedCities: [],
      isIndeterminate: true,
      visible: false
    };
  },
  methods: {
    handleCheckAllChange(val) {
      this.checkedCities = [];
      if (val) {
        this.colData.forEach(item => {
          this.checkedCities.push(item.title);
        });
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
      this.isIndeterminate = false;
      this.$emit("handleChange", [...this.checkedCities]);
    },
    handleCheckedCitiesChange(value) {
      this.checkedCities = [...value];
      const checkedCount = value.length;
      this.checkAll = checkedCount === this.colData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.colData.length;
      this.$emit("handleChange", [...this.checkedCities]);
    },
    handleReset() {
      this.checkedCities = [];
      this.colData.forEach(item => {
        this.checkedCities.push(item.title);
      });
      this.checkAll = true;
      this.isIndeterminate = false;
      this.$emit("handleChange", [...this.checkedCities]);
    },
    handleShow(val) {
      if (val) {
        this.checkedCities = [];
        this.colData.forEach(item => {
          if (this.newColData.includes(item.title)) {
            this.checkedCities.push(item.title);
          }
        });
        if (this.checkedCities.length === this.colData.length) {
          this.checkAll = true;
          this.isIndeterminate = false;
        }
      }
    }
  }
};
</script>

<style lang="less">
.FilterColumn {
  height: auto;
  max-height: 360px;
  width: 200px;
  overflow: auto;
  z-index: 4000 !important;

  .title {
    border-bottom: 1px solid #dcdfe6;
    padding-bottom: 8px;
  }
}

.aTooltip {
  width: 66px;
  left: auto !important;
  right: 25px;
}

.aTooltipArrow {
  width: 10px;
  left: auto !important;
  right: 5px;
}
</style>

<style scoped>
.el-checkbox {
  margin: 5px 0;
}

.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
</style>
